import {ChangeDetectionStrategy, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ControlRef, InputMode} from '@aviary/forms/fields/form-fields.types';
import {getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {provideControlRefTokenFor} from '@aviary/providers/control-ref.provider';

@Component({
  selector: 'mx-password-form-field',
  template: `
    <mx-input-form-field [fieldName]="fieldName" [inputType]="showPassword ? 'text' : 'password'" [overrideLabel]="overrideLabel"
                         [externalLabel]="externalLabel" [uppercaseExternalLabel]="uppercaseExternalLabel" [placeholder]="placeholder" [formGroup]="formGroup"
                         [includeClearButton]="includeClearButton" [maxLength]="maxLength" [inputMode]="inputMode"
                         [showValidationErrors]="showValidationErrors" [overrideBrowserAutocomplete]="overrideBrowserAutocomplete"
                         [auxiliaryButtonIconName]="showPassword ? 'visibility_off' : 'visibility'"
                         [auxiliaryButtonTooltip]="showPassword ? 'Hide' : 'Show'"
                         auxiliaryButtonIconClass="material-icons-outlined"
                         (auxiliaryButtonClick)="onAuxiliaryButtonClick()"/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideControlRefTokenFor(PasswordFormFieldComponent)],
  imports: [InputFormFieldComponent]
})
export class PasswordFormFieldComponent implements OnInit, ControlRef {
  @ViewChild(InputFormFieldComponent, {static: true}) private inputFormField: InputFormFieldComponent;

  @Input() public fieldName: string;
  @Input() public overrideLabel?: string;
  @Input() public externalLabel = false;
  @Input() public uppercaseExternalLabel = true;
  @Input() public placeholder = '';
  @Input() public formGroup: ExtendedFormGroup;
  @Input() public includeClearButton = true;
  @Input() public maxLength?: number;
  @Input() public inputMode?: InputMode;
  @Input() public showValidationErrors: boolean = true;
  @Input() public overrideBrowserAutocomplete?: string;

  public control: ExtendedFormControl;  // It's tempting to rename this to "formControl", but that's a reserved name and causes confusing errors.  So don't.
  public showPassword = false;

  public ngOnInit(): void {
    this.control = getExtendedControlFrom(this.formGroup, this.fieldName);
  }

  public onAuxiliaryButtonClick(): void {
    this.showPassword = !this.showPassword;
    requestAnimationFrame(() => this.inputFormField.moveCursorToEnd());
  }
}
